<div class="message-container" [attr.role]="inTour ? 'dialog' : 'status'" [attr.aria-label]="inTour ? 'Screen tour' : null">
    <div class="message" [innerHTML]="message"></div>
    @if (inTour) {
        <div class="tour-controls">
            <span class="step">{{step}} of {{count}}</span>
            <span class="spacer"></span>
            <button mat-button class="end" (click)="end.emit()">End tour</button>
            @if (step > 1) {
                <button mat-stroked-button class="back" (click)="back.emit()">Back</button>
            }
            <button mat-flat-button color="accent" (click)="next.emit()" cdkFocusInitial>{{step >= count ? 'Finish' : 'Next'}}</button>
        </div>
    }
</div>
